// extracted by mini-css-extract-plugin
module.exports = {"entryList":"entryList_entryList__1AKD2"};